export default __webpack_public_path__ + "media/images/builder_32-ca4212ddf2e1a8269d71fb083c6c59c3.png";